export default __webpack_public_path__ + "static/media/1586.3bc2e7ca.png";